// extracted by mini-css-extract-plugin
module.exports = {"whiteboardMenu":"WhiteboardMenu_whiteboardMenu__Fx2Kx"};